import axios from 'axios'
import Cookies from 'universal-cookie'
import queryString from 'query-string'

export function getCampaign(id, fetchStats, from, to) {
    return axios.get(`/api/campaign/${id}?stats=${fetchStats}&from=${from}&to=${to}`).then(res => res.data)
}

export function next(
    questionContainerId,
    answers,
    questionPageId,
    visitorSessionId,
    direction,
    skip = null,
    appType = null,
    affiliateTag = null,
    themeId = null,
    conversionTestKey = null,
    initPhoneNumber = null
) {
    let url = process.env.MIX_API_URL + '/aq/next'
    const cookies = new Cookies()
    const parsedQueryString = queryString.parse(window.location.search)
    const visitorHash = parsedQueryString['u'] ? parsedQueryString['u'] : cookies.get('vc')
    const hasReset = parsedQueryString['reset'] !== undefined

    return axios
        .post(url, {
            answers: answers,
            question_page_id: questionPageId,
            question_container_id: questionContainerId,
            theme_id: themeId,
            visitor_session_id: visitorSessionId,
            u: hasReset ? null : visitorHash,
            direction: direction,
            utm_campaign: parsedQueryString['utm_campaign'],
            utm_source: parsedQueryString['utm_source'],
            utm_medium: parsedQueryString['utm_medium'],
            utm_content: parsedQueryString['utm_content'],
            utm_term: parsedQueryString['utm_term'],
            subid: parsedQueryString['subid'],
            subid2: parsedQueryString['subid2'],
            subid3: parsedQueryString['subid3'],
            subid4: parsedQueryString['subid4'],
            subid5: parsedQueryString['subid5'],
            lsclid: parsedQueryString['lsclid'],
            gclid: parsedQueryString['gclid'],
            fbclid: parsedQueryString['fbclid'],
            ttclid: parsedQueryString['ttclid'],
            scclid: parsedQueryString['scclid'],
            adset_id: parsedQueryString['adset_id'],
            affiliate_tag: affiliateTag ? affiliateTag : parsedQueryString['affiliate_tag'],
            sqps: skip ? JSON.stringify(skip) : parsedQueryString['sqps'],
            prea: parsedQueryString['prea'],
            vs: parsedQueryString['vs'],
            qpg: parsedQueryString['qpg'],
            test: parsedQueryString['test'],
            e: parsedQueryString['e'],
            m: parsedQueryString['m'],
            parent: parsedQueryString['parent'],
            pi: parsedQueryString['pi'],
            appType: appType,
            entry_url: window.location.href,
            sup: parsedQueryString['sup'],
            conversionTestKey: conversionTestKey,
            pl: parsedQueryString['pl'],
            init_phonenumber: hasReset ? null : initPhoneNumber,
            preview: parsedQueryString['preview']
        })
        .then(res => res.data)
}

export function start() {
    let url = process.env.MIX_API_URL + '/aq/next'
    const cookies = new Cookies()

    const parsedQueryString = queryString.parse(window.location.search)

    let token = parsedQueryString['token']
    return axios
        .post(url, {
            is_pre_process_visit: 1,
            question_container_id: process.env.MIX_DEFAULT_QUESTION_CONTAINER_ID,
            u: cookies.get('vc'),
            utm_campaign: parsedQueryString['utm_campaign'],
            utm_source: parsedQueryString['utm_source'],
            utm_medium: parsedQueryString['utm_medium'],
            utm_content: parsedQueryString['utm_content'],
            utm_term: parsedQueryString['utm_term'],
            subid: parsedQueryString['subid'],
            subid2: parsedQueryString['subid2'],
            subid3: parsedQueryString['subid3'],
            subid4: parsedQueryString['subid4'],
            subid5: parsedQueryString['subid5'],
            affiliate_tag: parsedQueryString['affiliate_tag']
        })
        .then(res => res.data)
}

export function acceptCookies(visitorId) {
    let url = process.env.MIX_API_URL + '/aq/accept-cookies'
    return axios.post(url, { visitorId: visitorId }).then(res => res.data)
}

export function getValidateEmail(email) {
    let url = process.env.MIX_API_URL + '/aq/v/email?email=' + email
    return axios.get(url).then(res => res.data)
}

export function getCompanySuggestions(email) {
    let url = process.env.MIX_API_URL + '/get-company-suggestions?value=' + email
    return axios.get(url).then(res => res.data)
}

export function removeUploadedFile(visitorSessionId, key) {
    let url = process.env.MIX_API_URL + '/aq/upload/remove?visitorSessionId=' + visitorSessionId + '&key=' + key
    return axios.get(url).then(res => res.data)
}

export function fetchTheme(theme, includeDraft) {
    const queryParameters = includeDraft ? 'includeDraft=1' : ''
    return axios.get(process.env.MIX_API_URL + '/theme/' + theme.id + '?' + queryParameters).then(res => res.data)
}

export function storePrelanderAnswer(visitorSessionId, title, value) {
    let url = process.env.MIX_API_URL + '/aq/store-prelander-answer'
    return axios.post(url, { visitorSessionId: visitorSessionId, title: title, value: value }).then(res => res.data)
}

export function fetchResearches() {
    return axios.get(process.env.MIX_API_URL + '/research').then(res => res.data)
}
